const enAiVisibility = {
  'unlock-ai-visibility': 'Unlock AI Visibility',
  'ai-visibility-tracking': 'AI Visibility Tracking',
  'sign-up-for-ai-visibility': 'Sign up for AI Visibility',
  'update-ai-visibility-package': 'Update AI Visibility Credit Package',
  'cancel-ai-visibility-sub': 'Cancel AI Search Visibility subscription',
  'cancel-ai-visibility': 'Cancel AI Search Visibility',
  'are-you-sure-cancel-ai-visibility': 'Are you sure you want to cancel your AI Visibility Tracking subscription?',
  'unlock-ai-visibility-info':
    'Track how your content ranks across top AI search engines—<span class="link">Perplexity, ChatGPT, Google Gemini, and more.</span> Stay ahead with insights from a single, powerful dashboard.',
  'sign-up-ai-visibility': 'Sign up to AI Search Visibility',
  'monitor-your-visibility': 'Monitor your visibility in AI Search Engines',
  'subscribe-to-ai-visibility-desc':
    'Subscribe to our <a href="https://support.keyword.com/en/articles/11064187-getting-started-with-ai-visibility" class="link" target="_blank">AI Visibility Tracking</a> feature and gain powerful insights into how your content performs across the most popular AI search engines.',
  'choose-your-monthly-credits': 'Choose your monthly credits',
  'how-it-works': 'How it works',
  'subscribe-to-ai-visibility': 'Subscribe to AI Search Visibility',
  'take-control-ai-visibility': 'Take control of your AI Search visibility!',
  'take-control-ai-visibility-desc':
    'Subscribe to our <a href="https://support.keyword.com/en/articles/11064187-getting-started-with-ai-visibility" class="link" target="_blank">AI Visibility Tracking</a> feature and gain powerful insights into how your content performs across the most popular AI search engines.',
  'cancel-ai-visibility-note': `<b>Note:</b>
                                    <ul>
                                        <li>You can use your remaining credits until the end of your current billing period.</li>
                                        <li>All tracking history will be permanently deleted and cannot be undone.</li>
                                    </ul>
                                `,
  'unlock-ai-visibility-and-track-your-domains':
    'Unlock AI Visibility and track how your domains perform on AI-driven search engines!',
};

export default enAiVisibility;
